function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#797979",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(0 1)"
}, React.createElement("path", {
  fill: "#000",
  d: "M3.574 3.709H20.24c.313 0 .537.268.447.58l-2.323 7.596c-.045.179-.224.313-.447.313H6.166l-2.592-8.49z"
}), React.createElement("path", {
  d: "M0 0h2.547L6.97 15.191h9.562"
}), React.createElement("circle", {
  cx: 7.73,
  cy: 17.068,
  r: 1.743
}), React.createElement("circle", {
  cx: 16.487,
  cy: 17.068,
  r: 1.743
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-all-listings.efb07991.svg";
export { SvgComponent as ReactComponent };